import { render, staticRenderFns } from "./InternalAppointmentCommentsForm.vue?vue&type=template&id=178deb67"
import script from "./InternalAppointmentCommentsForm.vue?vue&type=script&lang=ts"
export * from "./InternalAppointmentCommentsForm.vue?vue&type=script&lang=ts"
import style0 from "./InternalAppointmentCommentsForm.vue?vue&type=style&index=0&id=178deb67&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports